import { create } from 'zustand';

import {
  apiFetchNotifications,
  apiMarkNotificationsAsDismissed,
  apiMarkNotificationsAsRead,
  apiMarkNotificationsAsViewed,
} from 'api/notification/apiUserNotificationEndpoints';
import { ApiNotification } from 'api/notification/types/ApiNotification';
import { MappedNotification } from 'types/mappedNotifications/MappedNotification';
import { sortNotifications } from 'utils/userNotifications';

const userNotificationsStore = create<{
  notifications: Array<MappedNotification | ApiNotification>;
  isFetching?: boolean;
  isLoaded: boolean;
}>(() => ({
  notifications: [],
  isFetching: false,
  isLoaded: false,
}));

const useUserNotificationsStore = userNotificationsStore; // The store can be used as a hook

function setNotifications(notifications: ApiNotification[]) {
  userNotificationsStore.setState({
    notifications: sortNotifications(notifications),
    isFetching: false,
    isLoaded: true,
  });
}

// Actions

export function fetchNotifications() {
  userNotificationsStore.setState({ isFetching: true });
  return apiFetchNotifications().then(setNotifications);
}

export function markNotificationsAsViewed(ids: Array<string>) {
  return apiMarkNotificationsAsViewed(ids).then(setNotifications);
}

export function markNotificationsAsRead(ids: Array<string>) {
  return apiMarkNotificationsAsRead(ids).then(setNotifications);
}

export function markNotificationsAsDismissed(ids: Array<string>) {
  return apiMarkNotificationsAsDismissed(ids).then(setNotifications);
}

// Hook

export function useUserNotifications() {
  const notifications = useUserNotificationsStore(
    (state) => state.notifications,
  );

  const isFetching = useUserNotificationsStore((state) => state.isFetching);

  return { notifications, isFetching };
}
